module.exports = __webpack_public_path__ + "static/media/SF UI Display Semibold.d14a5366.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SF-UI-Display/SF UI Display Semibold.svg
// module id = 216
// module chunks = 0